import classNames from 'classnames';

import {EqualWidthMode} from './equal-width-mode';
import {calculateProportionalWidths} from './helpers';
import {ProportionalMode} from './proportional-mode';
import type {PercentageProps, EqualWidthProps, ProportionalProps} from './types';

import styles from './distribution-bar.module.css';

export type Props = PercentageProps | EqualWidthProps | ProportionalProps;

export function DistributionBar(props: Props) {
    if (props.equalWidth) {
        return <EqualWidthMode sections={props.sections} />;
    }

    if (props.proportional) {
        const minWidthPercent = props.minWidthPercent || 10;
        const widths = calculateProportionalWidths(props.sections, minWidthPercent);

        return (
            <ProportionalMode
                sections={props.sections}
                widths={widths}
                borderVariant={props.borderVariant}
                size={props.size}
                showAsPercentage={props.showAsPercentage}
            />
        );
    }

    const totalPercent = props.sections.reduce((acc, section) => acc + section.percent, 0);
    const remainderPercent = 100 - totalPercent;

    return (
        <div className={styles['distribution-bar-container']}>
            {props.sections.map((section, index) => (
                <div
                    key={`${section.color}-${index}`}
                    style={{width: `${section.percent + 10}%`, backgroundColor: section.color}}
                    className={classNames(styles['bar-section'], {
                        [styles['bar-section--hoverable']]: Boolean(section.onClick),
                    })}
                    onClick={section.onClick}
                >
                    <div
                        className='flex flex-dir-col align-center'
                        style={{color: section.labelColor}}
                    >
                        <span className='font-bold'>{`${section.percent}%`}</span> {section.label}
                    </div>
                </div>
            ))}
            <div
                style={{
                    width: `${Math.max(0, remainderPercent - 20)}%`,
                    backgroundColor: props.remainder.color,
                }}
                className={classNames(styles['bar-section'], {
                    [styles['bar-section--hoverable']]: Boolean(props.remainder.onClick),
                })}
                onClick={props.remainder.onClick}
            >
                <div
                    className='flex flex-dir-col align-center'
                    style={{color: props.remainder.labelColor}}
                >
                    <span className='font-bold'>{`${remainderPercent}%`}</span>{' '}
                    {props.remainder.label}
                </div>
            </div>
        </div>
    );
}
